import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { CreateAgentDialog } from "./CreateAgentDialog.js";
import { CreateAgentV2Dialog } from "./agent-v2/CreateAgentV2Dialog.js";
export function AddAgentDialog({ workspaceId, onClose, onCreated }) {
    const [tab, setTab] = useState("claude-code");
    return (_jsx("div", { style: {
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.55)",
            display: "grid",
            placeItems: "center",
            zIndex: 100,
            padding: 24,
        }, children: _jsxs("div", { style: {
                width: "100%",
                maxWidth: 640,
                maxHeight: "90vh",
                display: "flex",
                flexDirection: "column",
                background: "var(--bg-secondary, #25262b)",
                color: "var(--text-primary, #e1e1e3)",
                border: "1px solid var(--border, #373a40)",
                borderRadius: 8,
                overflow: "hidden",
            }, children: [_jsxs("div", { style: {
                        display: "flex",
                        borderBottom: "1px solid var(--border, #373a40)",
                        background: "var(--bg-primary, #1a1b1e)",
                    }, children: [_jsx(TabButton, { active: tab === "claude-code", icon: _jsx(CrustaceanIcon, {}), label: "Claude Code", onClick: () => setTab("claude-code") }), _jsx(TabButton, { active: tab === "agent-v2", icon: _jsx(AgentV2Dot, {}), label: "Agent V2", onClick: () => setTab("agent-v2") }), _jsx("span", { style: { flex: 1 } }), _jsx("button", { type: "button", onClick: onClose, "aria-label": "Close", style: {
                                background: "none",
                                border: "none",
                                color: "var(--text-muted, #5c5f66)",
                                cursor: "pointer",
                                fontSize: 18,
                                padding: "0 16px",
                            }, children: "\u00D7" })] }), _jsxs("div", { style: { flex: 1, overflowY: "auto", padding: 18 }, children: [tab === "claude-code" && (
                        // Reuse the existing CreateAgentDialog body. It renders its
                        // own backdrop normally, but we're already inside a modal —
                        // we lift its content by passing a no-op onClose for the
                        // outer click since our own backdrop handles dismissal.
                        // Simplest: render it as-is, accept the double-modal during
                        // the migration window. A follow-up extracts the body into
                        // a non-portal-ed component the tabbed wrapper can host
                        // directly.
                        _jsx(CreateAgentDialog, { workspaceId: workspaceId, onClose: onClose, onCreated: onCreated })), tab === "agent-v2" && (_jsx(CreateAgentV2Dialog, { workspaceId: workspaceId, onClose: onClose, onCreated: onCreated }))] })] }) }));
}
function TabButton({ active, icon, label, onClick, }) {
    return (_jsxs("button", { type: "button", onClick: onClick, style: {
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            padding: "10px 18px",
            background: active ? "var(--bg-secondary, #25262b)" : "transparent",
            color: active ? "var(--text-primary, #e1e1e3)" : "var(--text-muted, #5c5f66)",
            border: "none",
            borderBottom: active ? "2px solid var(--accent, #7c5cfc)" : "2px solid transparent",
            font: "inherit",
            fontSize: 13,
            fontWeight: active ? 600 : 500,
            cursor: "pointer",
        }, children: [icon, label] }));
}
// Simplified crustacean — pixel-art crab matching the Claude Code
// mascot Akari pointed at in her screenshot. Scaled to a 14px grid
// so it sits cleanly next to the tab label.
function CrustaceanIcon() {
    // 7×7 grid; "1" = body, "2" = eyes, "3" = legs.
    const px = 2;
    const grid = [
        [0, 1, 1, 1, 1, 1, 0],
        [1, 1, 2, 1, 2, 1, 1],
        [1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1],
        [3, 1, 1, 1, 1, 1, 3],
        [3, 0, 0, 0, 0, 0, 3],
        [3, 0, 0, 0, 0, 0, 3],
    ];
    return (_jsx("span", { style: {
            display: "inline-grid",
            gridTemplateColumns: `repeat(7, ${px}px)`,
            width: 7 * px,
            height: 7 * px,
            gap: 0,
            flexShrink: 0,
        }, children: grid.flatMap((row, y) => row.map((cell, x) => (_jsx("span", { style: {
                width: px,
                height: px,
                background: cell === 1
                    ? "#d97757"
                    : cell === 2
                        ? "#1a1b1e"
                        : cell === 3
                            ? "#d97757"
                            : "transparent",
            } }, `${y}-${x}`)))) }));
}
function AgentV2Dot() {
    return (_jsx("span", { style: {
            width: 10,
            height: 10,
            borderRadius: "50%",
            background: "oklch(56% 0.11 45)",
            flexShrink: 0,
        } }));
}
//# sourceMappingURL=AddAgentDialog.js.map